module.exports = __webpack_public_path__ + "img/map-texture.3dd5624c.jpg";